export const environment = {
    baseUrl: process.env.VUE_APP_BASE_URL,
};
